import t from 'react-translate';
import { CellProps } from './types';
import { messageTypeMap } from '../constants';

const MessageTypeCell = ({ cell }: CellProps) => {
  const { title: messageType } = messageTypeMap(t)[
    cell.getValue()
  ];

  return <div className='black semi-bold pl-4'>{messageType}</div>;
};

export default MessageTypeCell;
